(function($){


   // Menu animations
    $('#trigger').on('click', function(){

        if($(this).hasClass('open')){

            $(this).removeClass('open');
            $('body').removeClass('disable');
            $('#mainMenu').removeClass('nav-open');

        } else {

            $('body').addClass('disable');
            $(this).addClass('open');

            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });
            $('#mainMenu').addClass('nav-open');

        }

    });

    $('#mainMenu a').on('click', function(){

    	if($('#trigger').hasClass('open')){

	        $('#trigger').removeClass('open');
	        $('body').removeClass('disable');
	        $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#mainMenu').removeClass('nav-open');
	    }

    });

   


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });



    //header on scroll

   /* $(window).scroll(function () {

        if( $(window).scrollTop() > 180 ) {
          $('#siteHeader').addClass('header-fixed');
          $logoAltURL = $('#company-alt-logo').attr('src');
          $('#company-alt-logo').fadeIn();
          $('#company-logo').hide();

        }
        if( $(window).scrollTop() < 180 ) {
          $('#siteHeader').removeClass('header-fixed');
           $logoURL = $('#company-logo').attr('src');
           $('#company-logo').fadeIn();
           $('#company-alt-logo').hide();
           console.log($logoURL);
        }
     })
   */




     //Parallax Animation
    var image = document.getElementsByClassName('obs-img');
          new trustPara(image, {
          maxTransition: 300
    });

    // Initiate aos animations
	AOS.init();

    /*
    // Initiate Rellax Scrolling
        window.onload = function(){
            var rellax = new Rellax('.rellax', {
            speed: -2,
            center: true,
            round: false,
            vertical: true,
            horizontal: true
        });

        $(window).scroll(function() {
            rellax.refresh();
        })
    }*/

    // Remove empty paragraphs
    $('p:empty:not([role])').remove();

	

})(jQuery);


document.addEventListener( 'wpcf7mailsent', function( event ) {
        if (event.detail.contactFormId == 414) {
            setTimeout( () => {
                window.location.href = '/contact/thank-you/?submitted=1';
            }, 500 ); // Wait for 0.5 second before redirect
        } 
    }, false );
